"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewSitePermission extends new_item_1.default {
    constructor(newSitePermission) {
        super();
        this.siteId = newSitePermission.siteId;
        this.orgId = newSitePermission.orgId;
        this.orgName = newSitePermission.orgName;
        this.permName = newSitePermission.permName;
    }
}
exports.default = NewSitePermission;
//# sourceMappingURL=new-sitePermission.js.map